export default function useWindowUtility() {

    return {
        groupTypes: [
            { "name": "Checkout Windows", "value": 1 },
            { "name": "Post Checkout Booking Windows", "value": 2 },
            { "name": "Pickup Windows", "value": 3 }
        ],
        limitModes: [
            { "name": "Limit by number of rates", "value": 1 },
            { "name": "Limit by number of dates", "value": 2 },
            { "name": "Limit by number of rates per day", "value": 3 }
        ],
        getGroupType: function (value) {
            let valueFormatted = parseInt(value);
            return this.groupTypes.find(x => x.value === valueFormatted);
        },
        getLimitMode: function (value) {
            let valueFormatted = parseInt(value);
            return this.limitModes.find(x => x.value === valueFormatted);
        }
    };
}
